import { render } from "./HoldRedigerKvittering.vue?vue&type=template&id=499ade07"
import script from "./HoldRedigerKvittering.vue?vue&type=script&lang=js"
export * from "./HoldRedigerKvittering.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__